import { Domain } from '../domains/domain';

export class Substatus {
  public id?: string;
  public name: string;
  public domain?: Domain;
}
